// extracted by mini-css-extract-plugin
export var actions = "_2j-0";
export var actionsContainer = "_2j-7";
export var border = "_2j-1";
export var childFullHeight = "_2j-f";
export var collapse = "_2j-2";
export var content = "_2j-a";
export var contentChild = "_2j-e";
export var fullscreen = "_2j-c";
export var hasLeftRadius = "_2j-k";
export var headerContainer = "_2j-3";
export var headerRow = "_2j-5";
export var hidePadding = "_2j-b";
export var navCollapsedGap = "_2j-l";
export var noScrollX = "_2j-m";
export var noScrollY = "_2j-n";
export var noTopPadding = "_2j-i";
export var optOutTopPadding = "_2j-d";
export var pageMain = "_2j-j";
export var pageOuter = "_2j-g";
export var pagePadding = "_2j-8";
export var pageScroll = "_2j-9";
export var profile = "_2j-o";
export var profileContainer = "_2j-p";
export var profileImage = "_2j-q";
export var profileMain = "_2j-r";
export var profileSubtitle = "_2j-t";
export var profileTitle = "_2j-s";
export var showLeftPadding = "_2j-h";
export var tabsPortalSlot = "_2j-6";
export var tabsWrapper = "_2j-4";
export var title = "_2j-u";